import { useQuery } from "@tanstack/react-query";
import { pathPickBasketQueryApi } from "@/features/pathpick/features/basket/api/query";
import { PathPickBasketCountsResponse } from "@/features/pathpick/features/basket/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 담은 상품 탭 배지 카운트 — 작업 전/등록 신청함/주문함을 한 번에 받는다.
// 탭·검색·필터와 무관한 담은 상품 전체 기준이고, 검색 결과 수는 별도 문구로 노출한다.
//
// suspense를 쓰지 않는다: 배지 하나 때문에 헤더 전체를 서스펜드시키는 대신
// 로딩 중에는 0으로 두고 도착하면 채운다.
const useGetPathPickBasketCounts = () => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickBasketCounts, isPending } = useQuery({
    queryKey: ["pathpick", "basket", "counts", companyId],
    // camel 변환을 queryFn에서 수행해 캐시 자체를 camel로 저장한다(이 폴더의 다른 쿼리와 동일).
    queryFn: async () => {
      const data = await pathPickBasketQueryApi.getPathPickBasketCounts(
        companyId as number
      );
      return toCamelKeyObject(data) as PathPickBasketCountsResponse;
    },
    enabled: Boolean(companyId),
  });

  return { pathPickBasketCounts, isPending };
};

export default useGetPathPickBasketCounts;
